import { ErrorHandler, inject, Injectable } from '@angular/core';
//import { AppInsightsService } from '@markpieszak/ng-application-insights';

import { AppInsightsService } from './app-insights-service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  //constructor(private appInsightsService: AppInsightsService) {}
  private appInsightsService = inject(AppInsightsService);
  

  handleError(error: any) {
    // Print the error to the console.
    console.error(error);
    //this.appInsightsService.trackException(error);

    this.appInsightsService.trackException(error);
  }
}
